export enum LocalStorageKeyEnum {
  AUTH_INFO = "authInfo",
  ACCESS_CODE = "accessCode",
  REFERRAL_CODE = "referralCode",
  OFAC = "ofac",
  LAST_CONNECTED_WALLET = "lastConnectedWallet",
  LAST_EIP6963_RDNS = "lastEIP6963Rdns",
  IMPORTED_ACCOUNT_ADDRESS = "importedAccountAddress",
  VOLATILITY_WARNING_BANNER = "volatilityWarningBanner",
  LAST_VIEWED_MARKET = "lastViewedMarket",
  WATCHLIST = "watchlist",
  WATCHLIST_STRIP_COLLAPSED = "watchlistStripCollapsed",
  CMDK_COLLAPSED_SECTIONS = "cmdkCollapsedSections",
  WATCHLIST_PAGE_COLLAPSED_SECTIONS = "watchlistPageCollapsedSections",
  WATCHLIST_PAGE_SECTION_ORDER = "watchlistPageSectionOrder",
  CMDK_SECTION_ORDER = "cmdkSectionOrder",
  SHOW_EARN_INTRO = "showSavingsIntro",
  SAVINGS_COLLATERAL_ACCUMULATED_YIELD = "savingsCollateralAccumulatedYield",
  TV_PREFERENCES = "tvPreferences",
  TV_CHART_STATE = "tvChartState",
  PERSISTENT_STATE = "persistentState",
  PWA_PROCESSED = "pwaProcessed",
  HIDE_BLUE_HEADER = "hideBlueHeader",
  ONE_CLICK_TRADING = "oneClickTrading",
  // Agents whose on-chain revoke FAILED and whose approval is still live. A
  // separate key on purpose: it must outlive the agent record, which is
  // replaced wholesale on re-enable and deleted on a successful revoke.
  ONE_CLICK_PENDING_REVOKE = "oneClickPendingRevoke",
  SUBACCOUNTS = "subaccounts",
  // Dev/QA-only feature-flag overrides. Ignored in production builds unless
  // REACT_APP_FEATURE_FLAG_DEV_OVERRIDES=true. See src/config/features.
  FEATURE_FLAG_OVERRIDES = "featureFlagOverrides",
}
